/**
 * © 2026 Grupo Salamander SAPI de CV
 *
 * Table overrides for the Renaissance design system (plan task 1.1, ported
 * from the redesign canvas). There is no `UITable` yet (task 3.1); these give
 * the raw MUI tables already in the product density-derived rows, a hairline
 * separator, sentence-case headers and the single easing curve.
 */

import type { TPaletteDefinition } from '../palette'
import { density, surface, transitionFor, type TDensity } from '../tokens'

export function tableOverrides(
  palette: TPaletteDefinition,
  mode: 'light' | 'dark',
  densityKey: TDensity = 'regular',
  reducedMotion = false
) {
  const d = density[densityKey]
  return {
    MuiTableCell: {
      styleOverrides: {
        root: {
          height: d.rowHeight,
          paddingBlock: 0,
          paddingInline: d.cellPaddingX,
          borderBottomColor: surface[mode].separator,
        },
        // Sentence case, no tracking — not Material's uppercase header.
        head: {
          fontWeight: 500,
          fontSize: d.fontSize - 1,
          letterSpacing: 0,
          textTransform: 'none' as const,
          color: palette.textSecondary.main,
          whiteSpace: 'nowrap' as const,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          transition: transitionFor(
            'feedback',
            ['background-color'],
            reducedMotion
          ),
        },
      },
    },
  }
}
